import { useEffect, useMemo } from 'react';
import { useUser } from '@/contexts/UserContext';
import { useOrganizationData } from '@/contexts/OrganizationContext';
import { pushIntercomEvent, getDashboardUrl } from '@/utils/intercomDataLayer';

// Centralizes the intercom_identify push. Splitting this across
// UserContext and OrganizationContext produced two non-deterministic
// events with disjoint payloads, leaving the GTM tag dependent on
// dataLayer merge semantics to reconstruct identity. Fires when the
// user or organization values sent to Intercom change.
export const IntercomIdentifyEffect = (): null => {
  const { user } = useUser();
  const { organization } = useOrganizationData();

  const identifyPayload = useMemo(() => {
    if (!user || !organization) return null;

    const sitename = organization.name;
    return {
      email: user.email,
      name: `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim(),
      astur_user_id: user.auth_id,
      organization_id: String(organization.id),
      organization_name: organization.title || organization.name,
      sitename,
      dashboard_url: getDashboardUrl(sitename),
    };
  }, [user, organization]);

  useEffect(() => {
    if (!identifyPayload) return;
    pushIntercomEvent('intercom_identify', identifyPayload);
  }, [identifyPayload]);

  return null;
};
